const noop = () => {};

export default noop;
